$(document).ready(function() {
  // cookies  code start *************************
function getValueFromLocalStorage(name) {
  return localStorage.getItem(name);
}
var trackingId = getValueFromLocalStorage('trackingId');
 var customer_login_mob_track = trackingId + '_track';
// cookies  code end  *********************************
  
   // Start login api CASA by Sandhya 
      var customer_login_status = $('body').attr('customer');   
      var customer_login_mob = $('body').attr('cus_mobile_no');
      //var customer_login_mob_track = $('body').attr('cus_mobile_no_track');
      var customer_login_name = $('body').attr('customername');
      var customer_login_email = $('body').attr('customeremail');
      // Get the current URL
      var currentURL = window.location.href;
      if (currentURL.includes('/account/login')) {
          var urlParams = new URLSearchParams(new URL(currentURL).search);
          var utm_parameter = urlParams.get('utm_source');
          console.log("utm_parameter sandhya", utm_parameter);
          if (utm_parameter) {
              localStorage.setItem('utm_source', utm_parameter);
          } else {
              localStorage.setItem('utm_source', 'ECOMM');
          }
      }
      if (customer_login_status) {
          var firstLogin = localStorage.getItem('firstLogin');
          if (!firstLogin) {
              localStorage.setItem('firstLogin', 'true');
              var utm_parameter_account = localStorage.getItem('utm_source');
              console.log("all_utm_para_account", utm_parameter_account);
          }
        var loginData = {
            mobile: customer_login_mob,
            trackingId: customer_login_mob_track,
            name: customer_login_name,
            email: customer_login_email,
            channel:utm_parameter_account,
        };
        if (!firstLogin) {
          localStorage.setItem('firstLogin', 'true');
            // fetch('https://api.iplanet.one/casa/customerlogin', {
            //     method: "POST",
            //     headers: {
            //         'Content-Type': 'application/json'
            //     },
            //     body: JSON.stringify(loginData)
            // }).then((response) => {
            //     return response.json();
            // }).then((response) => {
            //     console.log('Customer Login Data sent successfully on CASA !!', response);
            // }).catch((error) => {
            //     console.error('Error: ', error);
            // });
        } 
    }
        function logout() {
          console.log("logout click");
          localStorage.removeItem('firstLogin');
        }
      $('#logout_click').on('click', function(event) {
        console.log("logout click");
        logout();
      });
// end login api CASA by Sandhya
  
//for section/map-blogs
$('.map_upper_buttons a[href^="#"]').on('click', function(event) {
      var target = $($(this).attr('href'));
      if (target.length) {
         event.preventDefault();
         var scrollPosition = $(window).scrollTop();
         var scrollDistance = target.offset().top;
         $('html, body').animate({
            scrollTop: scrollDistance
         }, 500);
      }
      $('.map_upper_buttons a').removeClass('map_bg_color');
      $(this).addClass('map_bg_color');
   });
//for section/map-blogs
  
// to show the whatsapp icon & call icon in PDP from 9:30am to 6:30pm 
document.addEventListener("DOMContentLoaded", function() {
  // Get the current time
  var now = new Date();
  var hours = now.getHours();
  var minutes = now.getMinutes();
  
  // Calculate the time in minutes since midnight
  var currentTimeInMinutes = hours * 60 + minutes;
  
  // Define the start and end times (9:30 am and 6:30 pm)
  var startTimeInMinutes = 9 * 60 + 30;
  var endTimeInMinutes = 18 * 60 + 30;
  
  // Check if the current time is within the specified range
  if (currentTimeInMinutes >= startTimeInMinutes && currentTimeInMinutes <= endTimeInMinutes) {
    // Show the text
    document.getElementById("hiddenContact").style.cssText  = `
     display:flex;
     gap: 45%;
    `;
    } else {
      // Hide the text
      document.getElementById("hiddenContact").style.display = "none";
  }
});
    $('body').on('click','.cstm__shop-now',function(e){
      e.preventDefault();
   $('.company_popup_main').show();
  });
  $('body').on('click','.company_popup_close',function(){
    $('.company_popup_main').hide(); 
  });
    $('.SLIDE-1').slick({
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
   dots: false,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
 
  ]
});
   });